import * as React from 'react';
import { SVGProps } from 'react';

const SvgMaximizeVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
    <g clipPath="url(#clip0_4349_15817)">
      <path
        d="M15.376 7.71875L13.0008 5.34359L10.6257 7.71875"
        stroke="#1E0036"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6257 18.2812L13.0008 20.6564L15.376 18.2812"
        stroke="#1E0036"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0003 5.60971L13.0003 20.109"
        stroke="#1E0036"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0005 20.3882L13.0005 14.8462"
        stroke="#1E0036"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4349_15817">
        <rect width="17.9146" height="17.9146" fill="white" transform="translate(25.668 13) rotate(135)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMaximizeVertical;
